import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_API,
    prepareHeaders: (headers) => {
        try {
            // Retrieve tokens dynamically at request time
            const tokens = JSON.parse(sessionStorage.getItem("tokens")) || {};
            const api_key = JSON.parse(sessionStorage.getItem("api_key")) || {};

            if (tokens.access_token) {
                headers.set('Authorization', `Bearer ${tokens.access_token}`);
            }
            if (api_key.user_api_key) {
                headers.set('User_api_key', api_key.user_api_key);
            }
        } catch (error) {
            console.error("Error retrieving tokens:", error);
        }
        return headers;
    },
});

export const userApi = createApi({
  reducerPath: 'user',
  baseQuery,
  tagTypes: ["User"],
  endpoints: (builder) => ({
    getUserInfo: builder.query({
      query: () => ({
        url: "/info/",
        method: "GET",
      }),
    }),
    getUserPicture: builder.query({
      query: () => {
        return {
          url: "/profile_picture/",
          method: "GET",
        };
      },
    }),
    acceptDisclaimer: builder.mutation({
      query: (body) => ({
        url: "/change_diclaimer/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
    updatePassword: builder.mutation({
      query: (body) => ({
        url: "/update_password/",
        method: "POST",
        body
      })
    }),
    updateUser: builder.mutation({
      query: (body) => ({
        url: "/update/",
        method: "POST",
        body
      })
    })
  }),
});
  
export const { 
  useGetUserInfoQuery,
  useGetUserPictureQuery,
  useAcceptDisclaimerMutation,
  useUpdatePasswordMutation,
  useUpdateUserMutation
} = userApi;